import { render, staticRenderFns } from "./PrintRegistrationCard.vue?vue&type=template&id=07a700b4"
import script from "./PrintRegistrationCard.vue?vue&type=script&lang=js"
export * from "./PrintRegistrationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports